export default __webpack_public_path__ + "static/media/Google Play.164130ab.svg";